import React from 'react';
import { Plus, Trash2 } from 'lucide-react';
import { Button } from '../ui/Button';
import { Input } from '../ui/Input';

export const ExperienceForm = ({ data, onChange }) => {
  const addExperience = () => {
    const newExp = {
      id: Date.now().toString(),
      company: '',
      role: '',
      startDate: '',
      endDate: '',
      description: '',
    };
    onChange([...data, newExp]);
  };

  const removeExperience = (id) => {
    onChange(data.filter(exp => exp.id !== id));
  };

  const updateExperience = (id, field, value) => {
    onChange(data.map(exp => 
      exp.id === id ? { ...exp, [field]: value } : exp
    ));
  };

  return (
    <div className="space-y-6">
      {data.map((exp, index) => (
        <div key={exp.id} className="p-4 bg-gray-50 rounded-lg border border-gray-200 relative group">
          <div className="absolute top-4 right-4">
             <button onClick={() => removeExperience(exp.id)} className="text-gray-400 hover:text-red-500 transition-colors">
                <Trash2 size={18} />
             </button>
          </div>
          <h3 className="text-sm font-bold text-gray-500 mb-3 uppercase tracking-wider">Experience {index + 1}</h3>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <Input 
              label="Company" 
              value={exp.company} 
              onChange={(e) => updateExperience(exp.id, 'company', e.target.value)} 
            />
            <Input 
              label="Role" 
              value={exp.role} 
              onChange={(e) => updateExperience(exp.id, 'role', e.target.value)} 
            />
            <Input 
              label="Start Date" 
              value={exp.startDate} 
              onChange={(e) => updateExperience(exp.id, 'startDate', e.target.value)} 
              placeholder="e.g. Mar 2021"
            />
            <Input 
              label="End Date" 
              value={exp.endDate} 
              onChange={(e) => updateExperience(exp.id, 'endDate', e.target.value)} 
              placeholder="e.g. Present"
            />
            <div className="md:col-span-2">
              <label className="block text-sm font-medium text-gray-700 mb-1">Description</label>
              <textarea 
                className="w-full rounded-md border border-gray-300 px-3 py-2 text-gray-900 focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500 min-h-[100px]"
                value={exp.description}
                onChange={(e) => updateExperience(exp.id, 'description', e.target.value)}
                placeholder="Describe your responsibilities and achievements..."
              />
            </div>
          </div>
        </div>
      ))}
      
      <Button onClick={addExperience} variant="outline" className="w-full border-dashed">
        <Plus size={18} className="mr-2" /> Add Experience
      </Button>
    </div>
  );
};
